import { InputWrapper } from './input-wrapper';
import { Error } from './error';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label?: string;
  description?: string;
  preffix?: React.ReactNode;
  errors?: { [key: string]: ValidityState };
  rows?: number;
  inputRef?: React.RefObject<HTMLInputElement | HTMLTextAreaElement | null>;
}

export function Input({
  label,
  className = '',
  errors,
  preffix,
  description,
  inputRef,
  ...props
}: InputProps) {
  const showError = errors?.[props.name ?? ''];
  const inputProps = {
    className: `w-full outline-none ${className}`,
    ...props,
  };
  return (
    <div className="flex flex-col gap-1 w-full">
      <InputWrapper label={label} description={description} hasError={!!showError}>
        {preffix && (
          <span className="text-sm text-muted-foreground border-r border-neutral-200 pr-2 mr-2 whitespace-nowrap">
            {preffix}
          </span>
        )}
        {props.type === 'textarea' ? (
          <textarea ref={inputRef as React.RefObject<HTMLTextAreaElement>} {...inputProps} />
        ) : (
          <input ref={inputRef as React.RefObject<HTMLInputElement>} {...inputProps} />
        )}
      </InputWrapper>
      {showError && <Error fieldName={label} error={errors?.[props.name ?? '']} />}
    </div>
  );
}
